<template>
  <div>
    <div class="white-section mt-2">
      <b-form-group
        :label="$t('permissions.permissionGroups')"
        label-for="permissions-permissionGroups"
      >
        <my-v-select
          :key="selectedUserPermissionGroups[0]"
          id="permissions-permissionGroups"
          v-if="permissionGroups"
          :translate="false"
          v-model="selectedUserPermissionGroups"
          :label="'title'"
          :options="permissionGroups.length ? permissionGroups : []"
          :multiple="true"
        />
      </b-form-group>
      <!--    <vue-good-table-->
      <!--        v-if="permissions"-->
      <!--        :columns="columns"-->
      <!--        :rows="formattedPermissions"-->
      <!--        class="permission-table"-->
      <!--        styleClass="vgt-table "-->
      <!--    >-->
      <!--      <template slot="table-column" slot-scope="props">-->

      <!--         <span v-if="props.column.label === 'title'" class="text-nowrap">-->
      <!--              {{ $t("permissions.permissions") }}-->
      <!--            </span>-->
      <!--        <span v-else class="text-nowrap">-->

      <!--            </span>-->
      <!--      </template>-->

      <!--      &lt;!&ndash; Slot: Table Row &ndash;&gt;-->
      <!--      <template slot="table-row" slot-scope="props">-->
      <!--        <span v-if="props.column.field === 'title'" class="text-nowrap d-flex">-->
      <!--        &lt;!&ndash; Column: Name &ndash;&gt;-->
      <!--        <b-form-checkbox-->
      <!--            :id="`checkbox-${props.row.key}`"-->
      <!--            :value="props.row"-->
      <!--            @change="permissionChecked($event,props.row)"-->
      <!--        >-->
      <!--        </b-form-checkbox>-->
      <!--&lt;!&ndash;        <span v-if="props.column.field === 'permissions'" class="text-nowrap">&ndash;&gt;-->
      <!--  <span>-->
      <!--          {{ props.row.title }}</span>-->
      <!--&lt;!&ndash;        </span>&ndash;&gt;-->
      <!--        </span>-->
      <!--        <span v-if="props.column.field === 'child'" class="text-nowrap">-->
      <!--&lt;!&ndash;          {{props.row.children}}&ndash;&gt;-->
      <!--            <nested-table ref="nestedTable" v-if="props.row.children.length" :childColumns="childColumns"-->
      <!--              :children="props.row.children"></nested-table>-->
      <!--            </span>-->
      <!--      </template>-->
      <!--      <div slot="emptystate">-->

      <!--      </div>-->
      <!--    </vue-good-table>-->
      <div class="d-flex justify-content-end mb-2">
        <b-button @click="updateUser" variant="primary" size="sm"
          >{{ $t("general.submit") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapGetters } from "vuex";
import NestedTable from "@/components/NestedTable";
import { BFormCheckbox, BButton, BFormGroup, BOverlay } from "bootstrap-vue";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
export default {
  data: () => ({
    checkedItemChildren: [],
    formattedPermissions: [],
    flattenFormattedPermissions: [],
    loadPermissions: false,
    columns: [
      {
        label: "title",
        field: "title",
        sortable: false,
      },
      {
        label: "child",
        field: "child",
        sortable: false,
      },
    ],
    childColumns: [
      {
        label: "title",
        field: "title",
        sortable: false,
      },
      {
        label: "child",
        field: "child",
        sortable: false,
      },
    ],
  }),
  components: {
    MyVSelect,
    NestedTable,
    VueGoodTable,
    BFormCheckbox,
    BButton,
    BFormGroup,
    BOverlay,
  },
  computed: {
    ...mapGetters({
      permissions: "permissions/permissions",
      permissionGroups: "permissions/permissionGroups",
      userToEdit: "user/userToEdit",
    }),
    selectedUserPermissions: {
      get() {
        return this.$store.getters["permissions/selectedUserPermissions"];
      },
      set(permissions) {
        this.$store.commit(
          "permissions/SET_SELECTED_USER_PERMISSIONS",
          permissions
        );
      },
    },
    selectedUserPermissionGroups: {
      get() {
        return this.$store.getters["permissions/selectedUserPermissionGroups"];
      },
      set(permissions) {
        this.$store.commit(
          "permissions/SET_SELECTED_USER_PERMISSION_GROUPS",
          permissions
        );
      },
    },
  },
  mounted() {
    this.$store.commit("SET_IS_LOADING", true);

    this.$store.dispatch("permissions/getPermissions").then((res) => {
      this.createFormattedPermission(res);
      this.$store
        .dispatch("user/findUser", this.$route.params.userId)
        .then((res) => {
          this.pushBreadcrumb({
            text: "addPermissions",
            to: { name: "assignPermission" },
            params: { userId: this.$route.params.userId },
            translate: true,
          });
          this.pushBreadcrumb({
            text: res.firstName + " " + res.lastName,
            translate: false,
          });
          this.setCurrentBreadcrumb([
            {
              text: "addPermissions",
              to: { name: "assignPermission" },
              params: { userId: this.$route.params.userId },
              translate: true,
            },
            { text: res.firstName + " " + res.lastName, translate: false },
          ]);
          this.$store.commit("user/SET_USER_TO_EDIT", res);
          this.selectedUserPermissionGroups = res.permissionGroups
            ? res.permissionGroups
            : [];
          res.permissions.forEach((userPermission) => {
            this.selectedUserPermissions.push(
              this.flattenFormattedPermissions.find((p) => {
                if (p._id === userPermission) {
                  document.getElementById(`checkbox-${p.key}`)
                    ? (document.getElementById(
                        `checkbox-${p.key}`
                      ).checked = true)
                    : "";
                  // this.selectedUserPermissions.push(p)
                  this.checkParentElement(p);
                }
                return p._id === userPermission;
              })
            );
          });
          this.$store
            .dispatch("permissions/getPermissionGroups")
            .then((res) => {
              this.$store.commit("SET_IS_LOADING", false);
            });
        });
    });
  },
  methods: {
    permissionChecked(event, selected) {
      this.checkedItemChildren = [];
      this.getAllChildren(selected);
      if (event) {
        !this.selectedUserPermissions.find((s) => {
          return s._id === selected._id;
        })
          ? this.selectedUserPermissions.push(selected)
          : "";
        this.checkedItemChildren.forEach((c) => {
          !this.selectedUserPermissions.find((s) => {
            return s._id === c._id;
          })
            ? this.selectedUserPermissions.push(c)
            : "";
          document.getElementById(`checkbox-${c.key}`)
            ? (document.getElementById(`checkbox-${c.key}`).checked = true)
            : "";
        });
      } else {
        this.selectedUserPermissions.find((s) => {
          return s._id === selected._id;
        })
          ? (this.selectedUserPermissions = this.selectedUserPermissions.filter(
              (s) => {
                return s._id !== selected._id;
              }
            ))
          : "";
        this.checkedItemChildren.forEach((c) => {
          this.selectedUserPermissions.find((s) => {
            return s._id === c._id;
          })
            ? (this.selectedUserPermissions =
                this.selectedUserPermissions.filter((s) => {
                  return s._id !== c._id;
                }))
            : "";
          document.getElementById(`checkbox-${c.key}`)
            ? (document.getElementById(`checkbox-${c.key}`).checked = false)
            : "";
        });
      }
    },
    getAllChildren(node) {
      for (var i = 0; i < node.children.length; i++) {
        var child = node.children[i];
        this.getAllChildren(child);
        this.checkedItemChildren.push(child);
        // doSomethingToNode(child);
      }
    },
    flatten(array) {
      var result = [];
      let parent = this;
      array.forEach(function (a) {
        result.push(a);
        if (Array.isArray(a.children)) {
          result = result.concat(parent.flatten(a.children));
        }
      });
      return result;
    },
    checkParentElement(element) {
      let parentId = this.flattenFormattedPermissions.find((p) => {
        return p._id === element._id;
      }).parentId;
      if (parentId) {
        document.getElementById(
          `checkbox-${
            this.flattenFormattedPermissions.find((p) => {
              return p._id === parentId;
            }).key
          }`
        )
          ? (document.getElementById(
              `checkbox-${
                this.flattenFormattedPermissions.find((p) => {
                  return p._id === parentId;
                }).key
              }`
            ).checked = true)
          : "";
        this.selectedUserPermissions.push(
          this.flattenFormattedPermissions.find((p) => {
            return p._id === parentId;
          })
        );
      }
      if (
        this.flattenFormattedPermissions.find((p) => {
          return p._id === parentId;
        }) &&
        this.flattenFormattedPermissions.find((p) => {
          return p._id === parentId;
        }).parentId !== null
      ) {
        this.checkParentElement(
          this.flattenFormattedPermissions.find((p) => {
            return p._id === parentId;
          })
        );
      }
    },
    createFormattedPermission(res) {
      let list = _.cloneDeep(res);
      var map = {},
        node,
        roots = [],
        i;
      for (i = 0; i < list.length; i += 1) {
        map[list[i]._id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
          list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      this.formattedPermissions = roots;
      this.flattenFormattedPermissions = this.flatten(
        this.formattedPermissions
      );
    },
    updateUser() {
      let permissionsPayload = [];
      if (this.selectedUserPermissions.length) {
        this.selectedUserPermissions.forEach((s) => {
          s.children.length === 0 ? permissionsPayload.push(s._id) : "";
        });
      }
      const payload = {
        permissions: permissionsPayload,
        permissionGroups: this.selectedUserPermissionGroups,
      };
      this.$store
        .dispatch("user/editUser", {
          items: payload,
          userId: this.$route.params.userId,
        })
        .then((res) => {
          this.$root.$bvToast.toast(
            this.$t("toastification.submissionSucceed"),
            {
              // title: this.$t('toastification.success'),
              variant: "success",
              solid: true,
            }
          );
        });
    },
  },
};
</script>

<style lang="scss"></style>
